export const KURIKULUM_MERDEKA_DATA = [
  {
    image: '/images/landing/kurikulum-merdeka-book-icon.png',
    title: 'Tentang Kurikulum Merdeka',
    description:
      'Kenali prinsip dan konsep pembelajaran paradigma baru yang berpusat pada murid.',
    link: '/tentang-kurikulum-merdeka',
    slug: 'tentang-km',
  },
  {
    image: '/images/landing/kurikulum-merdeka-file-icon.png',
    title: 'Kumpulan Dokumen',
    description:
      'Lihat kumpulan dokumen panduan pelaksanaan Kurikulum Merdeka dengan mengklik tombol berikut',
    link: 'https://drive.google.com/drive/folders/1p7JrPQkHNIJIf2tjMefL_eNJFa2BUWY1',
    slug: 'kumpulan-dokumen',
  },
]
